/**
 * Navigation Constants for UI-Model-1
 */

export const VERTICAL_TABS = {
  LAYOUT: 'layout',
  THEME: 'theme',
  CSS: 'css',
} as const;
